/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import ResultItem, {
  EventImage,
  CategoryImage,
  LocationImage,
} from '../ResultItem';

const MAX_ITEMS = 6;
const MAX_TAGS_TO_SHOW = 1;
const MAX_LOCATIONS_TO_SHOW = 3;

const ResultList = ({
  disableLinkOut,
  events,
  tags,
  locations,
  hideLocation,
  hideTags,
  onEventClick,
  onTagClick,
  onLocationClick,
  setFirstItemUrl,
}) => {
  const locationCountToShow = !hideLocation
    ? locations.length < MAX_LOCATIONS_TO_SHOW
      ? locations.length
      : MAX_LOCATIONS_TO_SHOW
    : 0;

  const tagCountToShow = !hideTags
    ? tags.length < MAX_TAGS_TO_SHOW
      ? tags.length
      : MAX_TAGS_TO_SHOW
    : 0;

  const eventCountToShow = MAX_ITEMS - locationCountToShow - tagCountToShow;

  const tagComponents = tags
    .slice(0, tagCountToShow)
    .map(({ title, path }, index) => (
      <ResultItem
        disableLinkOut={disableLinkOut}
        image={CategoryImage()}
        title={title}
        permalink={path}
        key={path}
        onClick={() => onTagClick({ title, path, tagIndex: index })}
      />
    ));

  const eventComponents = events
    .slice(0, eventCountToShow)
    .map(({ title, path, location, image, eventId }, index) => (
      <ResultItem
        disableLinkOut={disableLinkOut}
        image={EventImage({ src: image, title })}
        title={title}
        subtext={location}
        permalink={path}
        key={path}
        onClick={() =>
          onEventClick({
            title,
            path,
            location,
            image,
            eventIndex: index,
            eventId,
          })
        }
      />
    ));

  const locationComponents = locations
    .slice(0, locationCountToShow)
    .map(({ name, permalink }, index) => (
      <ResultItem
        disableLinkOut={disableLinkOut}
        image={LocationImage()}
        title={name}
        permalink={permalink}
        key={permalink}
        onClick={() =>
          onLocationClick({
            title: name,
            path: permalink,
            locationIndex: index,
          })
        }
      />
    ));

  useEffect(() => {
    if (tags.length) {
      return setFirstItemUrl(tags[0].path);
    }

    if (locations.length) {
      return setFirstItemUrl(locations[0].permalink);
    }

    if (events.length) {
      return setFirstItemUrl(events[0].path);
    }
  }, [tags, locations, events]);

  return (
    <>
      {!hideTags && tagComponents}
      {!hideLocation && locationComponents}
      {eventComponents}
    </>
  );
};

export default ResultList;
